import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private oAuth = inject(OAuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.oAuth.getIdToken();
    const claims = this.oAuth.getIdentityClaims();
    if (token && req.url.includes(environment.apiBaseUrl)) {
      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (claims['login_type']) {
        localStorage.setItem('login_type', claims['login_type']);
      }
      return next.handle(clonedRequest).pipe(
        catchError(err => {
          console.error('Request error:', err);
          return throwError(() => err);
        })
      );
    }
    return next.handle(req);
  }
}
